import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/team-members/new/loading';

export const Route = createFileRoute('/_private/team-members/new')({
  pendingComponent: Loading,
});
